import SEOHead from '@/components/base/SEOHead';
import FeaturedSlider from './components/FeaturedSlider';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import PopularSection from './components/PopularSection';
import { aboutInfo } from '@/mocks/about';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '樱花动漫 - 免费漫画在线阅读平台',
    description: '樱花动漫整合免费漫画与漫画在线资源，专注日本漫画领域。热门推荐、最新更新、分类浏览，畅享漫画阅读体验。',
    url: 'https://sakuracomic.cn',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [],
    },
  };

  return (
    <>
      <SEOHead
        title="樱花动漫_免费漫画_漫画在线_日本漫画"
        description="樱花动漫整合免费漫画与漫画在线资源，专注日本漫画领域，服务广大动漫爱好者。收录超过5000部日本漫画，热门推荐、最新更新、分类浏览一应俱全。"
        keywords="樱花动漫,免费漫画,在线漫画,日本漫画,漫画在线阅读"
        canonicalUrl="https://sakuracomic.cn"
        schema={homeSchema}
      />

      <FeaturedSlider />

      <section className="py-10 md:py-14 bg-background-50 border-b border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {aboutInfo.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-3xl md:text-4xl font-heading font-semibold text-accent-500">{stat.value}</p>
                <p className="text-sm text-foreground-600 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PopularSection />
      <LatestUpdates />
      <CategorySection />
    </>
  );
}